import React from "react"
import styled from "styled-components"
import sunset from "../assets/images/cabin-sunset.jpg"
import bote from "../assets/images/mar-bote.jpg"
import cabin1 from "../assets/images/cabin2.jpg"
import cabin2 from "../assets/images/cabin4.jpg"

const GridPhotos = () => {
  return (
    <Wrapper className="section">
      <div className="section-center">
        <div class="section-title">
          <h2>Fresco, comodo y tranquilo</h2>
          <div class="underline"></div>
          <p>
            Es un lugar tranquilo para descansar, disfrutar de la playa, de la
            pesca deportiva. Cerca del parque Alerce Andino, Caleta la Arena,
            Puerto Montt y playa a tan solo 30 metros. Negocios locales a tan
            solo 4 minutos caminando. El living comedor con TV de 32 pulgadas y
            TV cable, combustión lenta y cocina full equipada. Baño con agua
            caliente. Dos piezas, una con cama matrimonial y la otra, con litera
            de plaza y media.
          </p>
        </div>
        <div className="projects-center">
          <div className="project-1">
            <article className="project">
              <img src={sunset} alt="single project" className="project-img" />
            </article>
          </div>

          <div className="project-2">
            <article className="project">
              <img src={bote} alt="single project" className="project-img" />
            </article>
          </div>

          <div className="project-3">
            <article className="project">
              <img src={cabin1} alt="single project" className="project-img" />
            </article>
          </div>

          <div className="project-4">
            <article className="project">
              <img src={cabin2} alt="single project" className="project-img" />
            </article>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background-color: var(--primary-100);
  width: 100%;

  .section-title {
    text-align: center;
    h2 {
      text-transform: uppercase;
    }

    p {
      max-width: 50rem;
      margin: 2rem auto;
      padding: 0 3rem;
      letter-spacing: var(--letterSpacing);
    }
  }
`

export default GridPhotos
